import { cn } from '@eombor/ui';

export interface BrandMarkProps {
  className?: string;
}

/**
 * E-ombor nishonchasi: tomi, ikki devori va ochiq eshigi bo'lgan ombor,
 * eshikdan chiqib kelayotgan ikkita rels.
 *
 * Geometriya `apps/web/public/favicon.svg` bilan AYNAN bir xil — brauzer
 * yorlig'idagi va ilova ichidagi belgi bir narsa bo'lishi kerak. Farqi bitta:
 * bu yerda rang `currentColor`, shuning uchun u qo'yilgan joyning temasiga
 * ergashadi (yorug' temada quyuq `--color-accent`, qorong'ida ochroq).
 *
 * `aria-hidden` — belgining yonida doim ilova nomi matn bilan turadi,
 * ekran o'quvchi uchun uni ikki marta o'qish ortiqcha.
 */
export const BrandMark = ({ className }: BrandMarkProps) => (
  <svg
    aria-hidden
    viewBox="0 0 32 32"
    fill="currentColor"
    className={cn('size-8 shrink-0', className)}
  >
    {/* tom — eng keng va eng qalin bo'lak: 16 pikselda ham shakl shundan tanilaydi */}
    <path d="M16 3 31.2 11.5v3.6L16 6.6.8 15.1v-3.6z" />
    {/* bino; eshik ochig'i `evenodd` bilan o'yib olingan (ichida quticha yo'q — kichik o'lchamda ular faqat iflos qiladi) */}
    <path fillRule="evenodd" d="M16 6.4 27.6 12.9V23.5H4.4V12.9zM10.8 14.6v8.9h10.4v-8.9z" />
    {/* ikkita rels — eshikdan tomoshabinga qarab ajralib boradi */}
    <path d="M15.5 18.2h-3l-6.3 12h3zM16.5 18.2h3l6.3 12h-3z" />
  </svg>
);
